<span matDialogTitle>{{ data.title | siaTranslate }}</span>
<mat-dialog-content>
  @if (data.description) {
    <span>{{ data.description | siaTranslate }}</span>
  }
  <mat-form-field class="w-full">
    <mat-label>{{ 'Commento' | siaTranslate }}</mat-label>
    <textarea matInput [(ngModel)]="feedback"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="onYesClick()"
    [class]="data.negativeMeaning ? 'error' : ''"
    [autofocus]="true"
  >
    {{ 'Sì, conferma' | siaTranslate }}
  </button>
  <button mat-button (click)="onNoClick()" class="button-grey">
    {{ 'No, continua' | siaTranslate }}
  </button>
</mat-dialog-actions>
